<template>
  <table
    class="table b-table b-table-stacked-xs table-bordered table-sm bg-white text-uppercase"
  >
    <tbody>
      <tr>
        <td colspan="4">
          De que forma a família (ou membro da família) acessou a Unidade para o primeiro
          atendimento?:
          <span v-if="item.forma">
            <b>
              {{
                $root.arrays.forma_ingresso.filter((el) => {
                  return el.id == item.forma;
                })[0]["value"]
              }}
            </b></span
          >
        </td>
      </tr>
      <tr>
        <td>
          Nome da unidade/órgão de origem: <b>{{ item.nome_unidade_origem }}</b>
        </td>
        <td>
          Contato do órgão/unidade: <b>{{ item.nome_contato_unidade_origem }}</b>
        </td>
      </tr>
      <tr>
        <td colspan="4">
          Quais as razões, demandas ou necessidades que motivaram o primeiro atendimento?
          <b class="d-block" v-html="item.descricao_ingresso"></b>
        </td>
      </tr>
      <tr>
        <td colspan="4">
          Assinale abaixo caso a família seja beneficiária, ou algum de seus membros, de
          pelo menos um dos seguintes programas sociais:
          <span v-if="item.beneficiaria_programa_ingresso">
            <b>
              {{
                $root.arrays.programas.filter((el) => {
                  return el.id == item.beneficiaria_programa_ingresso;
                })[0]["value"]
              }}
            </b></span
          >
        </td>
      </tr>
      <tr>
        <td colspan="12">
          Nome do programa prioritário: <b>{{ item.nome_programa_ingresso }}</b>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: ["item", "loading"],
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
